// DO NOT USE THIS FILE
// For history, it keeps some constants for api prefixes
// For new variables, prefer using config configurations/environment-variables.json
// Also see files : src/environments/environment[-prod].ts and inspectionmanager/environments/environment[-prod].ts 
// if variable depends on prod/dev or manager/browser application

export const environment = {
  api_url: '/api',
  auth_url: '/api',
};
